import { Header } from "src/components";
import styles from './styles.module.css';
import useScrollToTop from "src/hooks/useScrollToTop";
import { useTranslation } from "react-i18next";


const Privacy = () => {
    useScrollToTop();
    const { t } = useTranslation(["common"]);

    return (
        <div className={styles.privacy}>
            <Header title={t("privacy.title")} />
            <div className="container">
                <div className="row">
                    <div className="col-12 col-lg-8 pt-5 mt-4">
                        <section className={styles.content}>
                            <h1 className={styles.heading}>{t("privacy.heading")}</h1>
                            <p className={styles.paragraph}>
                                {t("privacy.intro")}
                            </p>
                            <h2 className={styles.subheading}>{t("privacy.informationWeCollect")}</h2>
                            <ul className={styles.list}>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.personalInfo.title")}</b>
                                        {t("privacy.personalInfo.description")}
                                    </div>
                                </li>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.usageInfo.title")}</b>
                                        {t("privacy.usageInfo.description")}
                                    </div>
                                </li>
                            </ul>
                            <h2 className={styles.subheading}>{t("privacy.usage")}</h2>
                            <ul className={styles.list}>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.services.title")}</b>
                                        {t("privacy.services.description")}
                                    </div>
                                </li>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.improveSite.title")}</b>
                                        {t("privacy.improveSite.description")}
                                    </div>
                                </li>
                            </ul>
                        </section>
                    </div>
                    <div className="col-12 col-lg-10 pb-5">
                        <section className={styles.content}>
                            <h2 className={styles.subheading}>{t("privacy.protectingInfo")}</h2>
                            <ul className={styles.list}>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.securityMeasures.title")}</b>
                                        {t("privacy.securityMeasures.description")}
                                    </div>
                                </li>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.sharingInfo.title")}</b>
                                        {t("privacy.sharingInfo.description")}
                                    </div>
                                </li>
                                <li className={styles.listItem}>
                                    <div>
                                        <b className="">{t("privacy.policyUpdates.title")}</b>
                                        {t("privacy.policyUpdates.description")}
                                    </div>
                                </li>
                            </ul>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Privacy;
